export const select = (value?: string) => ({
  selected: {
    value: undefined,
    label: '',
  },
  error: {
    show: false,
    messages: [],
  },
  ready: false,
  open: false,

  toggle() {
    if (this.open) {
      return this.close();
    }
    this.$refs.button.focus();
    this.open = true;
  },

  close(focusAfter) {
    if (!this.open) return;
    this.open = false;
    focusAfter && focusAfter.focus();
  },

  validate() {
    const newErrors = {
      show: false,
      messages: [],
    };

    const selectElement = this.$refs.select as HTMLSelectElement;
    const required = selectElement.required;
    let label = (this.$refs.label as HTMLLabelElement).textContent || '';

    if (label) label = label.replace('*', '').trim();

    if (required && this.selected.value === undefined) {
      newErrors.messages.push(`${label || 'Dieses Feld'} ist erforderlich.`);
      newErrors.show = true;
    }

    if (newErrors.messages.length) {
      newErrors.show = true;
      selectElement.setCustomValidity('Fehler');
    } else {
      newErrors.show = false;
      selectElement.setCustomValidity('');
    }

    this.error = newErrors;

    selectElement.checkValidity();
  },

  setInitialSelected() {
    if (value === undefined) return;

    let label: string;
    const target = this.$refs.select as HTMLElement;

    target.querySelectorAll('option').forEach((node) => {
      if (node.value === value) {
        label = node.innerText;
      }
    });

    if (label) {
      this.selected = {
        label,
        value,
      };
    }
  },

  onInvalid() {
    this.validate();
    this.ready = true;
  },

  onChange() {
    this.validate();
    this.ready = true;
  },

  init() {
    this.$watch('selected', () => this.validate());
    this.$watch('open', (newValue: boolean) => {
      if (!newValue) {
        this.ready = true;
      }
    });
    this.setInitialSelected();
    this.validate();
  },
});
